import React from "react";
import Logo from "../../assets/images/logo-white.png";
import axios from "axios";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import 'react-toastify/dist/ReactToastify.css';
import { getPendingVerification, savePendingVerification, clearPendingVerification, verificationError } from '../../helpers/PendingVerification';
class Registration extends React.Component {
  constructor(props) {
    super(props);
    const pending = getPendingVerification();
    const verificationEmail = props.location?.state?.verificationEmail || pending?.email || '';
    this.state = {
      formData:{
        name:"",
        surname:"",
        email:"",
        phone:"",
        password:"",
        password_confirmation:"",
        business_name:"",
        // business_phone:"",
        // business_email:"",
        // city_id:"",
        // district_id:"",
        // address:"",
        // admin_identitiy:"",
        // logo:null,
      },
      loading:false,
      cities:[],
      districts:[],
      step: verificationEmail ? 'otp' : 'register',
      emailForOtp: verificationEmail,
      otpCode:'',
      otpLoading:false,
      resendLoading:false,
      resendCooldown: pending?.email === verificationEmail ? Math.max(0, Math.ceil((pending.resendUntil - Date.now()) / 1000)) : 0,
      otpError:''
    };
    this.resendTimer = null;
  }
  // getCities = async () => {
  //   const response = await apiCall('get-cities', 'get', null);
  //   this.setState({ cities: response });
  // }

  // handleCityChange = async (event) => {
  //   const city_id = event.target.value;
  //   this.setState(prevState => ({
  //     formData: {
  //       ...prevState.formData,
  //       city_id: city_id,
  //       district_id: ""
  //     },
  //     districts: []
  //   }));
  //
  //   if (city_id) {
  //     const response = await apiCall(`get-dist/${city_id}`, 'get', null);
  //     this.setState({ districts: response });
  //   }
  // }
  componentWillUnmount(){
    if (this.resendTimer){
      clearInterval(this.resendTimer);
    }
  }

  startCooldown = (seconds = 60) => {
    if (this.resendTimer){
      clearInterval(this.resendTimer);
    }
    savePendingVerification(this.state.emailForOtp, seconds);
    this.setState({resendCooldown:seconds});
    this.resendTimer = setInterval(() => {
      this.setState(prev => {
        if (prev.resendCooldown <= 1){
          clearInterval(this.resendTimer);
          return {resendCooldown:0};
        }
        return {resendCooldown: prev.resendCooldown - 1};
      });
    },1000);
  }

  sendOtp = async () => {
    const {emailForOtp} = this.state;
    if (!emailForOtp || this.state.resendLoading || this.state.resendCooldown > 0){
      return;
    }
    this.setState({resendLoading:true, otpError:''});
    try{
      const response = await axios.post(process.env.REACT_APP_API_URL+'otp/send',{email:emailForOtp});
      if (response.data.already_verified) {
        clearPendingVerification();
        this.props.history.push('/login');
        return;
      }
      this.setState({ otpCode: '' });
      mainHelper.toastMessage('success','Doğrulama kodu telefonunuza SMS olarak gönderildi.');
      this.startCooldown(response.data.remaining_seconds || 60);
    }catch (error){
      mainHelper.handleErrors(error?.response?.data?.errors || error?.response?.data || {},error?.response?.status);
      this.setState({otpError: verificationError(error)});
      const seconds = Number(error?.response?.data?.remaining_seconds);
      if (error?.response?.status === 429 && seconds > 0) this.startCooldown(seconds);
    }finally {
      this.setState({resendLoading:false});
    }
  }

  handleVerify = async (e) => {
    e.preventDefault();
    const {emailForOtp, otpCode} = this.state;
    if (this.state.otpLoading) return;
    if (!/^\d{6}$/.test(otpCode)) { this.setState({ otpError: 'Lütfen 6 haneli doğrulama kodunu girin.' }); return; }
    this.setState({otpLoading:true, otpError:''});
    try{
      await axios.post(process.env.REACT_APP_API_URL+'otp/verify',{email:emailForOtp, code:otpCode});
      clearPendingVerification();
      mainHelper.toastMessage('success','Doğrulama başarılı. Girişe yönlendiriliyorsunuz.');
      this.props.history.push('/login');
    }catch (error){
      mainHelper.handleErrors(error?.response?.data?.errors || error?.response?.data || {},error?.response?.status);
      this.setState({otpError: verificationError(error)});
    }finally {
      this.setState({otpLoading:false});
    }
  }

  handleChange = (e) => {
    const {id,value,files} = e.target;
    this.setState(prevState =>({
      formData: {
        ...prevState.formData,
        [id]:files ? files[0] : value
      }
    }));
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const formData = new FormData();
    const allowed = ['name','surname','email','phone','password','password_confirmation','business_name'];
    allowed.forEach(key => {
      formData.append(key, this.state.formData[key]);
    });
    axios.post(process.env.REACT_APP_API_URL+'register',formData)
        .then(response => {
         if (response.data.success){
           mainHelper.toastMessage('success','Kayıt oluşturuldu. Telefonunuza gelen SMS koduyla doğrulamayı tamamlayın.');
           savePendingVerification(this.state.formData.email);
           this.setState({
             step:'otp',
             emailForOtp: this.state.formData.email
           },() => {
             this.sendOtp();
           });
         }
        })
        .catch(error => {
          mainHelper.handleErrors(error.response.data.errors,error.response.status)
        })
        .finally(() => {

          this.setState({loading: false});


        })
  }

  componentDidMount(){
    if (this.state.step === 'otp') {
      savePendingVerification(this.state.emailForOtp, this.state.resendCooldown);
      if (this.state.resendCooldown > 0) this.startCooldown(this.state.resendCooldown);
    }
    document.body.classList.remove("theme-cyan");
    document.body.classList.remove("theme-purple");
    document.body.classList.remove("theme-blue");
    document.body.classList.remove("theme-green");
    document.body.classList.remove("theme-orange");
    document.body.classList.remove("theme-blush");
    // this.getCities();
  }
  render() {
    const {loading,step,resendCooldown,resendLoading,otpLoading,otpError,otpCode,emailForOtp} = this.state;
    const isOtpStep = step === 'otp';
    return (
        <div className="theme-cyan">
          <div>
            <div className="vertical-align-wrap">
              <div className="vertical-align-middle auth-main">
                <div className="auth-box">
                  <div className="top">
                    <img src={Logo} alt="Servicezone" style={{width: "190px", margin: "10px"}}/>
                  </div>
                  <div className="card">
                    <div className="header">
                      <p className="lead">{isOtpStep ? 'E-Posta Doğrulama' : 'Hesap Oluştur'}</p>
                    </div>
                    <div className="body">
                      {!isOtpStep && (
                      <form className="form-auth-small ng-untouched ng-pristine ng-valid" onSubmit={this.handleSubmit}
                            encType="multipart/form-data">
                        <div className="row clealfix">
                          <div className="col-lg-12 col-md-12">
                            <div className="row">
                              <div className="col-lg-12 col-md-12">
                                <h6>İşletme Sahibi</h6>
                                <div className="form-group">
                                  <label className="control-label sr-only">Ad</label>
                                  <input
                                      className="form-control"
                                      id="name"
                                      placeholder="Adınız"
                                      type="text"
                                      value={this.state.formData.name}
                                      onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">
                                    Soyad
                                  </label>
                                  <input
                                      className="form-control"
                                      id="surname"
                                      placeholder="Soyadınız"
                                      type="text"
                                      value={this.state.formData.surname}
                                      onChange={this.handleChange}
                                  />
                                </div>
                                {/**
                                <div className="form-group">
                                  <label className="control-label sr-only">TC</label>
                                  <input
                                      className="form-control"
                                      id="admin_identitiy"
                                      placeholder="İşletme Sahibi TC"
                                      type="number"
                                      value={this.state.formData.admin_identitiy}
                                      onChange={this.handleChange}
                                  />
                                </div>
                                **/}
                                <div className="form-group">
                                  <label className="control-label sr-only">
                                    Telefon
                                  </label>
                                  <input
                                      className="form-control"
                                      id="phone"
                                      placeholder="Telefon Numaranız"
                                      type="text"
                                      value={this.state.formData.phone}
                                      onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">
                                    Email
                                  </label>
                                  <input
                                      className="form-control"
                                      id="email"
                                      placeholder="E-Mail Adresinizi"
                                      type="email"
                                      value={this.state.formData.email}
                                      onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">İşletme Adı</label>
                                  <input
                                      className="form-control"
                                      id="business_name"
                                      placeholder="İşletme Adı"
                                      type="text"
                                      value={this.state.formData.business_name}
                                      onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">
                                    Şifre
                                  </label>
                                  <input
                                      className="form-control"
                                      id="password"
                                      placeholder="Şifre"
                                      type="password"
                                      value={this.state.formData.password}
                                      onChange={this.handleChange}
                                  />
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">
                                    Şifre Tekrar
                                  </label>
                                  <input
                                      className="form-control"
                                      id="password_confirmation"
                                      placeholder="Şifre Tekrar"
                                      type="password"
                                      value={this.state.formData.password_confirmation}
                                      onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-12">
                                {/* İşletme Bilgileri alanları sadeleştirme kapsamında taşındı */}
                                {/**
                                <div className="form-group">
                                  <label className="control-label sr-only">İşletme Adı</label>
                                  <input className="form-control" id="business_name" placeholder="İşletme Adı" type="text" value={this.state.formData.business_name} onChange={this.handleChange} />
                                </div>
                                **/}

                                {/**
                                <div className="form-group">
                                  <label className="control-label sr-only">Telefon</label>
                                  <input className="form-control" id="business_phone" placeholder="İşletme Telefon" type="text" value={this.state.formData.business_phone} onChange={this.handleChange} />
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">Email</label>
                                  <input className="form-control" id="business_email" placeholder="İşletme E-Mail Adresi" type="email" value={this.state.formData.business_email} onChange={this.handleChange} />
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">İl</label>
                                  <select className="form-control" id="city_id" onChange={this.handleCityChange}>
                                    <option value="">İl Seçiniz</option>
                                    {cities && (cities.map(city => (
                                        <option key={city.id} value={city.id}>{city.name}</option>
                                    )))}
                                  </select>
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">İlçe</label>
                                  <select className="form-control" id="district_id" onChange={this.handleChange}>
                                    <option value="">İlçe Seçiniz</option>
                                    {districts && (districts.map(district => (
                                        <option key={district.id} value={district.id}>{district.name}</option>
                                    )))}
                                  </select>
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">Adres</label>
                                  <textarea className="form-control" id="address" placeholder="İşletme adresi" value={this.state.formData.address} onChange={this.handleChange} />
                                </div>
                                <div className="form-group">
                                  <label className="control-label sr-only">İşletme logosu</label>
                                  <input className="form-control" id="logo" type="file" ref={this.fileInputRef} onChange={this.handleChange} />
                                </div>
                                **/}
                              </div>
                            </div>
                          </div>
                        </div>

                        {loading ? (

                                <button className="btn btn-primary btn-lg btn-block" disabled={true}
                                        style={{textAlign: "-webkit-center"}}>
                                  Lütfen Bekleyin... <ReactLoading type="spin" color="#ffffff" width={'24px'}
                                                                   height={'24px'}></ReactLoading>
                                </button>

                            ) :
                            <button className="btn btn-primary btn-lg btn-block" type="submit">
                              Kaydol
                            </button>
                        }

                        <div className="bottom">
                        <span className="helper-text">
                          Hesabınız var mı?{" "}
                          <a href="login">Giriş yap</a>
                        </span>
                        </div>
                      </form>
                      )}

                      {isOtpStep && (
                          <form className="form-auth-small" onSubmit={this.handleVerify}>
                            <div className="form-group">
                              <p className="text-muted">
                                {emailForOtp} hesabınız için kayıtlı telefonunuza gelen 6 haneli SMS kodunu girin. Kod 5 dakika geçerlidir; yeniden kod isterseniz en son gelen kodu kullanın.
                              </p>
                            </div>
                            <div className="form-group">
                              <label className="control-label sr-only">Doğrulama Kodu</label>
                              <input
                                  className="form-control"
                                  id="otpCode"
                                  placeholder="000000"
                                  type="text"
                                  maxLength={12}
                                  inputMode="numeric"
                                  autoComplete="one-time-code"
                                  name="code"
                                  aria-label="SMS doğrulama kodu"
                                  value={otpCode}
                                  onChange={(e)=> this.setState({ otpCode: e.target.value.replace(/\D/g, '').slice(0, 6), otpError: '' })}
                              />
                            </div>
                            {otpError && (
                                <div className="alert alert-danger" role="alert">
                                  {otpError}
                                </div>
                            )}
                            <div className="form-group clearfix">
                              {otpLoading ? (
                                  <button className="btn btn-primary btn-lg btn-block" disabled={true}
                                          style={{textAlign: "-webkit-center"}}>
                                    Doğrulanıyor...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                                                color="#ffffff"></ReactLoading>
                                  </button>
                              ) :
                                  <button className="btn btn-primary btn-lg btn-block" type="submit">
                                    Doğrula ve Devam Et
                                  </button>}
                            </div>
                            <div className="form-group clearfix d-flex justify-content-between align-items-center">
                              <span className="text-muted">
                                Kod gelmedi mi?
                              </span>
                              <button
                                  type="button"
                                  className="btn btn-link"
                                  disabled={resendLoading || resendCooldown > 0}
                                  onClick={this.sendOtp}
                              >
                                {resendLoading ? 'Gönderiliyor...' : resendCooldown > 0 ? `Tekrar gönder (${resendCooldown})` : 'Tekrar gönder'}
                              </button>
                            </div>
                            <button type="button" className="btn btn-link" disabled={otpLoading || resendLoading}
                              onClick={() => { clearPendingVerification(); if (this.resendTimer) clearInterval(this.resendTimer); this.setState({ step: 'register', emailForOtp: '', otpCode: '', otpError: '', resendCooldown: 0 }); }}>
                              Başka hesap oluştur
                            </button>
                          </form>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}


export default Registration;
